<template>
  <div>
    <form action="logout" method="POST" class="block">
      <input type="hidden" name="_token" :value="csrfToken" />
      <header class="bg-white border-b md:border-gray-500 md:px-4 h-24 px-2 w-full flex">
        <div class="flex w-full items-center justify-between max-w-default mx-auto">
          <a href="/">
            <img class="h-16" src="svg/logo.svg" alt="Logo Bremen Login" />
          </a>
          <div class="hidden md:flex flex-1 h-16 items-center ml-4" v-if="authorized">
            <v-button
              small
              class="mr-2 border-none"
              icon="far fa-user-alt"
              :title="__('zu der Einstellung')"
              href="settings"
              >{{ userName }}</v-button
            >
            <v-button
              small
              class="border-none"
              type="submit"
              :title="__('aus der Seite ausloggen')"
              icon="far fa-sign-out"
              >{{ __('Logout') }}
            </v-button>
          </div>

          <v-button
            v-if="authorized"
            @click="set_navigation_visibility(!navigation_visibility)"
            icon="far fa-bars"
            :title="__('Hauptnavigation öfnen')"
            >{{ __('Menü') }}</v-button
          >
        </div>
      </header>
      <div v-if="authorized">
        <div
          @click="set_navigation_visibility(false)"
          class="fixed bg-black inset-0 z-20 transform transition-all ease-in-out duration-300"
          :class="{
            'visible opacity-50': navigation_visibility,
            'invisible opacity-0': !navigation_visibility,
          }"
        ></div>
        <nav
          :tabindex="tabindex"
          id="navigation"
          class="
            fixed
            overflow-auto
            bg-white
            bottom-0
            right-0
            max-w-sm
            shadow-2xl
            top-0
            w-full
            z-30
            transform
            transition-all
            ease-in-out
            duration-300
            focus:-translate-x-0
          "
          :class="{
            '-translate-x-0': navigation_visibility,
            'translate-x-full': !navigation_visibility,
          }"
        >
          <div class="flex justify-end h-24 items-center px-2 md:px-4">
            <v-button
              @click="set_navigation_visibility(false)"
              icon="far fa-times"
              :title="__('Hauptnavigation schließen')"
              >{{ __('schließen') }}</v-button
            >
          </div>
          <ul class="text-blue-500">
            <li v-for="(item, index) in navigationItems" :key="index" class="m-2">
              <div v-if="item.items" class="p-2">
                <div class="flex items-center w-full mb-2">
                  <span v-if="item.icon" class="pr-2" :class="item.icon"></span>
                  <span v-html="item.title"></span>
                </div>
                <a
                  :tabindex="tabindex"
                  v-for="subItem in item.items"
                  class="link text-sm block py-2 px-6"
                  :href="subItem.link"
                  v-on:click="set_navigation_visibility(false)"
                  ><span class="pr-2" v-if="subItem.icon" :class="subItem.icon"></span>{{ subItem.title }}</a
                >
              </div>
              <a :tabindex="tabindex" v-else class="link block p-2" :href="item.link"
                ><span :class="item.icon" class="pr-2"></span>{{ item.title }}</a
              >
            </li>
            <li class="m-4">
              <v-button
                :tabindex="tabindex"
                type="submit"
                :title="__('aus der Seite ausloggen')"
                icon="far fa-sign-out"
                >{{ __('Logout') }}</v-button
              >
            </li>
          </ul>
          <v-button
            :tabindex="tabindex"
            @click="set_navigation_visibility(!navigation_visibility)"
            class="opacity-0"
            :title="__('Hauptnavigation öffnen / schließen')"
          >
            {{ __('Hauptnavigation öffnen / schließen') }}
          </v-button>
        </nav>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    authorized: { type: Boolean, default: false },
    csrfToken: { type: String, default: '' },
    userName: { type: String, default: '' },
  },
  data: () => ({
    navigationItems: [
      {
        title: 'Meine Brancheneinträge',
        icon: 'far fa-id-card-alt',
        items: [
          {
            title: 'Alle Auflisten',
            icon: 'far fa-list',
            link: 'institutions',
          },
          {
            title: 'Neu Erstellen',
            icon: 'far fa-plus',
            link: 'institution#/booking',
          },
        ],
      },
      {
        title: 'Meine gewerblichen Anzeigen',
        icon: 'far fa-tags',
        items: [
          {
            title: 'Anzeige kaufen',
            icon: 'far fa-shopping-cart',
            link: 'advertisement#/booking-advertisement',
          },
          {
            title: 'Alle Auflisten',
            icon: 'far fa-list',
            link: 'advertisements',
          },
          {
            title: 'Neu Erstellen',
            icon: 'far fa-plus',
            link: 'advertisements/create',
          },
        ],
      },
      {
        title: 'Meine Veranstaltungen',
        icon: 'far fa-calendar-alt',
        items: [
          {
            title: 'Alle Auflisten',
            icon: 'far fa-list',
            link: 'events',
          },
          {
            title: 'Neu Erstellen',
            icon: 'far fa-plus',
            link: 'events/create',
          },
        ],
      },
      {
        title: 'Mein Konto',
        icon: 'far fa-user-alt',
        link: 'settings',
      },
    ],
  }),
  computed: {
    navigation_visibility() {
      return this.$store.state.navigation_visibility;
    },
    tabindex() {
      return this.$store.state.navigation_visibility ? 0 : -1;
    },
  },
  mounted() {
    document.addEventListener('keydown', (event) => {
      if (event.code == 'Escape') {
        this.set_navigation_visibility(false);
      }
    });
  },
  methods: {
    set_navigation_visibility(value) {
      this.$store.commit('set_navigation_visibility', value);
      if (this.navigation_visibility) {
        document.querySelector('#navigation').focus();
      }
    },
  },
};
</script>
